import React, { FunctionComponent } from "react";
import useCustomizationContext from "../../../../../hooks/useCustomizationContext";
import { Panel } from "../../../../../states/customization";
import { hasSelectionInPanel } from "../../../../../utils/customization/configuration";
import {
  findPageAndDefinition,
  findPageDefinitionsWithValidCondition,
} from "../../../../../utils/customization/finders";
import { buildRotationPagesMapping } from "../../../../../utils/customization/page";
import EditionPanelTabs from "../../../../molecules/customization/panels/EditionPanelTabs";
import SelectionContent from "./SelectionContent";
import StylesContent from "./StylesContent";
import "./style.scss";

interface Props {
  elementDefinitionKey?: string;
  openTab?: "photos" | "styles";
  pageKey: string;
}
const PageEditionPanel: FunctionComponent<Props> = ({
  elementDefinitionKey,
  openTab = "styles",
  pageKey,
}) => {
  const {
    configuration,
    content,
    dispatch,
    template,
    ui: { defaultFontKey },
  } = useCustomizationContext();

  const hasSelection = hasSelectionInPanel(template);
  const handleClickTabs = (selectedTab: "photos" | "styles") => {
    dispatch({ key: pageKey, openedTab: selectedTab, panel: Panel.EDITPAGE, type: "setPanel" });
  };

  // todo : change findPageAndDefinition to avoid these hack because of throw
  if (!content.pages.find((page) => page.key === pageKey)) {
    dispatch({ panel: Panel.CLOSED, type: "setPanel" });
    return null;
  }

  const { pageDefinition } = findPageAndDefinition(pageKey, template, content);
  const pageDefinitions = findPageDefinitionsWithValidCondition(template, content, {
    filterType: pageDefinition.filterType,
    type: pageDefinition.type,
  });
  const rotationPairsMapping = buildRotationPagesMapping(template.pageDefinitions);
  const hasLayouts =
    pageDefinitions.length > 2 ||
    (pageDefinitions.length === 2 && Object.keys(rotationPairsMapping).length === 0);

  const editableTexts = pageDefinition.elementDefinitions.filter(
    ({ type }) => type === "editable-text"
  );

  const hasFonts = editableTexts && editableTexts.length > 0 && template.fontDefinitions.length > 1;

  const hasColors = pageDefinition && pageDefinition.backgroundColorKeys.length > 1;

  const hasStyles = hasLayouts || hasFonts || hasColors;

  return (
    <div className="PageEditionPanel">
      {hasSelection && hasStyles && (
        <EditionPanelTabs onClick={handleClickTabs} openTab={openTab} />
      )}
      <div className="PageEditionPanel-content">
        {openTab === "styles" && (
          <StylesContent
            configuration={configuration}
            content={content}
            defaultFontKey={defaultFontKey}
            dispatch={dispatch}
            pageKey={pageKey}
            template={template}
          />
        )}
        {openTab === "photos" && (
          <SelectionContent elementDefinitionKey={elementDefinitionKey} pageKey={pageKey} />
        )}
      </div>
    </div>
  );
};

export default PageEditionPanel;
